import { Box, Typography } from "@material-ui/core";
import { ActionLink, CloseButtonIcon, MobilePopoverCard } from "halifax";
import React from "react";
import clsx from "clsx";

import styles from "./styles.module.scss";

export interface IExperiencesMobilePopoverCardProps {
  headerText: string | JSX.Element;
  content: JSX.Element;
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  className?: string;
}

export const ExperiencesMobilePopoverCard = ({
  headerText,
  content,
  isOpen,
  setOpen,
  className,
}: IExperiencesMobilePopoverCardProps) => (
  <MobilePopoverCard
    open={isOpen}
    headerElement={
      <Box
        className={styles["experiences-mobile-popover-card-header-container"]}
      >
        <Typography className={styles["header-title"]}>{headerText}</Typography>
        <ActionLink
          className={styles["close-button"]}
          content={<CloseButtonIcon />}
          label="Close"
          onClick={() => {
            setOpen(false);
          }}
        />
      </Box>
    }
    onClose={() => {
      setOpen(false);
    }}
    className={clsx(styles["experiences-mobile-popover-card-root"], className)}
    contentClassName={styles["experiences-mobile-popover-card-content"]}
    centered
  >
    {content}
  </MobilePopoverCard>
);
